import React from "react"
import { BanIcon, CircleUserRound, File, Image, MapPin, Mic, SquarePlay, Sticker } from "lucide-react"
import WarningIcon from "../assets/viewonce.svg"
import ClockFading from "../assets/ClockFading"
const validateMedia = (ultimaMenssagem) => {
  switch (ultimaMenssagem) {
    case "_INFO_VIDEO_INFO_":
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <SquarePlay size={16} style={{ marginRight: 2, marginBottom: 2 }} />
          <span>Vídeo</span>
        </div>
      )
    case "_INFO_AUDIO_INFO_":
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Mic size={16} style={{ marginRight: 2, marginBottom: 2 }} />
          <span>Áudio</span>
        </div>
      )
    case "_INFO_IMAGE_INFO_":
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Image size={16} style={{ marginRight: 2, marginBottom: 2 }} />
          <span>Imagem</span>
        </div>
      )
    case "_INFO_STICKER_INFO_":
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Sticker style={{ marginRight: 2, height: 12, width: 12, marginBottom: 2 }} />
          <span>Figurinha</span>
        </div>
      )
    case "_INFO_MESSAGE_RESTRICTED_INFO_":
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <BanIcon size={16} style={{ marginRight: 2, marginBottom: 2 }} />
          <span>Mensagem restrita</span>
        </div>
      )
    case "_INFO_PROTOCOL_EPHEMERAL_SETTING_INFO_":
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <ClockFading size={16} style={{ marginRight: 2, marginBottom: 2 }} />
          <span>Mensagens temporárias</span>
        </div>
      )
    case "_INFO_MESSAGE_DELETED_INFO_":
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            textDecoration: "line-through",
            fontStyle: "italic",
            overflowWrap: "break-word",
            textDecoration: "line-through",
          }}
        >
          <BanIcon size={12} style={{ marginRight: 2, marginBottom: 2 }} />
          <span>Mensagem apagada</span>
        </div>
      )
    case "_INFO_LOCATIONMESSAGE_INFO_":
    case "_INFO_LIVELOCATIONMESSAGE_INFO_":
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <MapPin size={16} style={{ marginRight: 2, marginBottom: 2 }} />
          <span>Localização</span>
        </div>
      )
    case "_INFO_CONTACTMESSAGE_INFO_":
    case "_INFO_CONTACTSARRAYMESSAGE_INFO_":
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <CircleUserRound size={16} style={{ marginRight: 2, marginBottom: 2 }} />
          <span>Contato</span>
        </div>
      )
    default:
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <File size={16} style={{ marginRight: 2, marginBottom: 2 }} />
          <span>Arquivo</span>
        </div>
      )
  }
}
const textoTruncar = (texto, limite) => {
  if (texto?.startsWith("_INFO_") && texto?.endsWith("_INFO_") && texto !== "_INFO_") {
    return validateMedia(texto)
  }
  if (texto?.startsWith("data:image/")) {
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <MapPin size={16} style={{ marginRight: 2, marginBottom: 2 }} />
        <span>Localização</span>
      </div>
    )
  }
  if (texto === "ERR_VIEW_ONCE_MESSAGE") {
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img src={WarningIcon} alt="Warning" style={{ marginRight: 2, height: 12, width: 12, marginBottom: 2 }} />
        <span>Foto</span>
      </div>
    )
  }
  if (texto?.includes("BEGIN:VCARD")) {
    const hasMultipleVCards = (texto.match(/BEGIN:VCARD/g) || []).length > 1
    const nameMatch = texto.match(/FN:(.*)/)
    const contactName = nameMatch ? nameMatch[1] : "Unknown"
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <CircleUserRound size={16} style={{ marginRight: 2, marginBottom: 2 }} />
        <span>{hasMultipleVCards ? "Vários contatos" : contactName}</span>
      </div>
    )
  }

  if (texto?.length > limite) {
    return texto.substring(0, limite) + "..."
  }
  return texto
}

export default textoTruncar
